import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#4f46e5',
            dark: '#4338ca',
            light: '#818cf8',
        },
        secondary: {
            main: '#0f766e',
        },
        success: {
            main: '#0f9f6e',
        },
        warning: {
            main: '#d97706',
        },
        background: {
            default: '#f8fafc',
            paper: '#ffffff',
        },
        text: {
            primary: '#0f172a',
            secondary: '#475569',
        },
        divider: '#dbe2ea',
        grey: {
            50: '#f8fafc',
            100: '#f1f5f9',
            200: '#e2e8f0',
            300: '#cbd5e1',
            400: '#94a3b8',
        },
    },
    typography: {
        fontFamily: '"Inter", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
        h1: {
            fontWeight: 700,
            fontSize: '3.25rem',
            lineHeight: 1.08,
        },
        h2: {
            fontWeight: 600,
            fontSize: '2.4rem',
            lineHeight: 1.12,
        },
        h3: {
            fontWeight: 700,
            fontSize: '1.75rem',
        },
        h4: {
            fontWeight: 700,
            fontSize: '1.375rem',
        },
        h5: {
            fontWeight: 700,
            fontSize: '1.125rem',
        },
        button: {
            fontWeight: 600,
            textTransform: 'none',
        },
        body1: {
            lineHeight: 1.7,
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    background:
                        'linear-gradient(180deg, #ffffff 0%, #f8fafc 28%, #eef2ff 100%)',
                },
                '#root': {
                    minHeight: '100vh',
                },
                a: {
                    color: 'inherit',
                },
                '::selection': {
                    backgroundColor: '#c7d2fe',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(255,255,255,0.88)',
                    color: '#0f172a',
                    boxShadow: 'none',
                    borderBottom: '1px solid #dbe2ea',
                    backdropFilter: 'blur(14px)',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
                rounded: {
                    borderRadius: 8,
                },
                outlined: {
                    borderColor: '#dbe2ea',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    border: '1px solid #dbe2ea',
                    boxShadow: '0 18px 40px rgba(15, 23, 42, 0.06)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
                    '&:hover': {
                        transform: 'translateY(-3px)',
                        boxShadow: '0 24px 48px rgba(79, 70, 229, 0.12)',
                        borderColor: '#a5b4fc',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    paddingInline: 18,
                    paddingBlock: 10,
                    boxShadow: 'none',
                },
                containedPrimary: {
                    boxShadow: '0 14px 30px rgba(79, 70, 229, 0.18)',
                    '&:hover': {
                        boxShadow: '0 18px 36px rgba(79, 70, 229, 0.24)',
                    },
                },
                outlined: {
                    borderWidth: 1,
                    '&:hover': {
                        borderWidth: 1,
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    backgroundColor: '#ffffff',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    fontWeight: 600,
                },
            },
        },
    },
});

export default theme;
